import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/entrancePlants/helpSetup/help-set-up-the-plant.webp'

const _withId = /*#__PURE__*/_withScopeId("data-v-6ae26ead")

_pushScopeId("data-v-6ae26ead")
const _hoisted_1 = { class: "bt-icon bt-icon--xs" }
const _hoisted_2 = { class: "ml-2" }
const _hoisted_3 = /*#__PURE__*/_createVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_4 = { class: "p-4 lower-half" }
const _hoisted_5 = { class: "text-primary" }
const _hoisted_6 = /*#__PURE__*/_createVNode("br", null, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_InlineSvgScoped = _resolveComponent("InlineSvgScoped")
  const _component_Button = _resolveComponent("Button")
  const _component_ElDropdownItem = _resolveComponent("ElDropdownItem")
  const _component_ElDropdownMenu = _resolveComponent("ElDropdownMenu")
  const _component_ElDropdown = _resolveComponent("ElDropdown")

  return (_openBlock(), _createBlock(_component_ElDropdown, {
    onVisibleChange: _ctx.handleDropdownVisibleChange,
    trigger: "click",
    placement: "right-end",
    "popper-class": "el-dropdown__popper el-dropdown--context"
  }, {
    dropdown: _withId(() => [
      _createVNode(_component_ElDropdownMenu, null, {
        default: _withId(() => [
          _createVNode(_component_ElDropdownItem, null, {
            default: _withId(() => [
              _hoisted_3,
              _createVNode("div", _hoisted_4, [
                _createVNode("h6", _hoisted_5, _toDisplayString(_ctx.description), 1),
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.callModeHelpDescription, (text, index) => {
                  return (_openBlock(), _createBlock("span", { key: index }, [
                    _createTextVNode(_toDisplayString(text) + " ", 1),
                    _hoisted_6
                  ]))
                }), 128))
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    default: _withId(() => [
      _createVNode(_component_Button, {
        class: ["p-button-rounded ml-auto", _ctx.showHelpDialog ? 'p-button-primary' : 'p-button-outlined'],
        onClick: _ctx.toggleHelpDialog
      }, {
        default: _withId(() => [
          _createVNode("span", _hoisted_1, [
            _createVNode(_component_InlineSvgScoped, {
              src: 
                        require(`@/assets/images/icons/icon-alert-medium-outline.svg`)
                    ,
              "aria-label": "icon-alert"
            }, null, 8, ["src"])
          ]),
          _createVNode("span", _hoisted_2, _toDisplayString(_ctx.title), 1)
        ]),
        _: 1
      }, 8, ["class", "onClick"])
    ]),
    _: 1
  }, 8, ["onVisibleChange"]))
})